import CloseIcon from '../../../assets/icons/close.svg?react';
import { useDeleteReportTemplate } from '../../../hooks/queries/reportQueries';
import { useState } from 'react';

const ReportTemplateDeleteModal = ({ onClose, target, onDeleteSuccess }) => {
  const deleteReportTemplate = useDeleteReportTemplate();
  const [isPending, setIsPending] = useState(false);

  const handleDelete = async () => {
    setIsPending(true);
    try {
      await deleteReportTemplate.mutateAsync(target.ReportTemplateInfoSysId);
      onDeleteSuccess();
    } catch (error) {
      console.error('템플린 삭제 실패:', error);
      alert('템플린 삭제에 실패했습니다.');
    }
    finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>템플릿 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="text-b2-400 text-gray-800 my-10">템플릿을 삭제하시겠습니까?</p>
          <table className='gray-table'>
            <tr>
              <th>템플릿명</th>
              <td>{target.TemplateName}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn py-5 px-10 btn-style-5" onClick={onClose}>취소</button>
          <button className="btn py-5 px-10 btn-primary" onClick={handleDelete} disabled={isPending}>{isPending ? '삭제 중...' : '삭제'}</button>
        </div>
      </div>
    </div>
  )
}

export default ReportTemplateDeleteModal